import React from 'react';
import classNames from 'classnames';

import css from './IconBrandCard.module.css';

const LOCATION = 'location';
const STAR = 'star';
const CALENDAR = 'calendar';
const ARROWRIGHT = 'arrowright';
const ARROWLEFT = 'arrowleft';
const SEARCH = 'search';
const BOTTOMARROW = 'bottomarrow';
const TOPARROW = 'toparrow';
const YOUTUBE = 'youtube';
const INSTAGRAM = 'instagram';

/**
 * Payment card icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {'amex' | 'diners' | 'discovery' | 'jcb' | 'mastercard' | 'unionpay' | 'visa'} props.type payment card provider
 * @returns {JSX.Element} SVG icon
 */
const IconBrandCard = props => {
  const { className, rootClassName, type = 'default' } = props;
  const classes = classNames(rootClassName || css.root, className);

  switch (type) {
    case YOUTUBE:
      return (
        <svg
          width="30"
          height="21"
          viewBox="0 0 30 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_6256_36572)">
            <path
              d="M28.6484 3.63189C28.4846 3.02654 28.165 2.47467 27.7216 2.03122C27.2782 1.58778 26.7263 1.26823 26.121 1.1044C23.9049 0.5 14.9857 0.5 14.9857 0.5C14.9857 0.5 6.066 0.518295 3.84986 1.1227C3.24451 1.28654 2.69265 1.6061 2.24922 2.04957C1.80579 2.49303 1.48628 3.04493 1.32249 3.65029C0.652161 7.58793 0.392128 13.588 1.3409 17.3681C1.5047 17.9735 1.82422 18.5253 2.26765 18.9688C2.71108 19.4122 3.26293 19.7318 3.86827 19.8956C6.08441 20.5 15.0038 20.5 15.0038 20.5C15.0038 20.5 23.9232 20.5 26.1392 19.8956C26.7445 19.7318 27.2964 19.4122 27.7399 18.9688C28.1833 18.5254 28.5029 17.9735 28.6667 17.3681C29.3737 13.4249 29.5916 7.42852 28.6484 3.63189Z"
              fill="#99A1AF"
            />
            <path d="M12.1465 14.7287L19.5455 10.4601L12.1465 6.19141V14.7287Z" fill="#27272A" />
          </g>
          <defs>
            <clipPath id="clip0_6256_36572">
              <rect width="28.5574" height="20" fill="white" transform="translate(0.721191 0.5)" />
            </clipPath>
          </defs>
        </svg>
      );
    case INSTAGRAM:
      return (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_6256_36576)">
            <path
              d="M10 2.30187C12.6701 2.30187 12.9863 2.31203 14.0408 2.36008C15.0158 2.40461 15.5453 2.5675 15.8977 2.70445C16.3645 2.88586 16.6976 3.10258 17.0475 3.4525C17.3975 3.80242 17.6141 4.13555 17.7955 4.60227C17.9325 4.95469 18.0954 5.48422 18.1399 6.45914C18.188 7.51367 18.1981 7.82992 18.1981 10.5C18.1981 13.1702 18.188 13.4864 18.1399 14.5409C18.0954 15.5159 17.9325 16.0453 17.7955 16.3977C17.6141 16.8645 17.3974 17.1977 17.0475 17.5476C16.6976 17.8975 16.3645 18.1142 15.8977 18.2955C15.5453 18.4325 15.0158 18.5955 14.0408 18.6399C12.9865 18.688 12.6702 18.6982 10 18.6982C7.32969 18.6982 7.01344 18.688 5.95914 18.6399C4.98414 18.5954 4.45469 18.4325 4.10227 18.2955C3.63555 18.1142 3.30234 17.8975 2.95242 17.5476C2.6025 17.1976 2.38578 16.8645 2.20445 16.3977C2.0675 16.0454 1.90453 15.5159 1.86008 14.5409C1.81195 13.4864 1.8018 13.1702 1.8018 10.5C1.8018 7.82992 1.81195 7.51367 1.86008 6.45922C1.90461 5.48422 2.0675 4.95469 2.20445 4.60227C2.38578 4.13555 2.6025 3.80242 2.95242 3.4525C3.30242 3.1025 3.63555 2.88586 4.10227 2.70445C4.45461 2.5675 4.98414 2.40461 5.95914 2.36008C7.01359 2.31203 7.32984 2.30187 10 2.30187ZM10 0.5C7.28414 0.5 6.94359 0.511484 5.87703 0.560156C4.81258 0.60875 4.08562 0.777812 3.44961 1.025C2.79195 1.28055 2.2343 1.6225 1.67836 2.17844C1.12242 2.73438 0.780547 3.29203 0.525 3.94961C0.277734 4.5857 0.10875 5.31266 0.0601562 6.37703C0.0114844 7.44359 0 7.78414 0 10.5C0 13.2159 0.0114844 13.5564 0.0601562 14.623C0.10875 15.6874 0.277734 16.4144 0.525 17.0504C0.780469 17.708 1.12242 18.2657 1.67836 18.8216C2.2343 19.3776 2.79195 19.7195 3.44961 19.975C4.0857 20.2223 4.81258 20.3913 5.87695 20.4398C6.94359 20.4885 7.28414 20.5 10 20.5C12.7159 20.5 13.0564 20.4885 14.123 20.4398C15.1873 20.3913 15.9143 20.2223 16.5503 19.975C17.208 19.7195 17.7656 19.3776 18.3216 18.8216C18.8775 18.2657 19.2195 17.708 19.475 17.0504C19.7222 16.4143 19.8913 15.6874 19.9398 14.623C19.9885 13.5564 20 13.2159 20 10.5C20 7.78414 19.9885 7.44359 19.9398 6.37703C19.8913 5.31266 19.7222 4.5857 19.475 3.94969C19.2195 3.29203 18.8775 2.73438 18.3216 2.17844C17.7656 1.6225 17.208 1.28047 16.5504 1.025C15.9143 0.777812 15.1873 0.60875 14.123 0.560156C13.0564 0.511484 12.7159 0.5 10 0.5ZM10 5.36484C7.16391 5.36484 4.86484 7.66406 4.86484 10.5C4.86484 13.3361 7.16391 15.6352 10 15.6352C12.836 15.6352 15.1352 13.3361 15.1352 10.5C15.1352 7.66398 12.836 5.36484 10 5.36484ZM10 13.8334C8.15906 13.8334 6.66664 12.3409 6.66664 10.5C6.66664 8.65906 8.15906 7.16664 10 7.16664C11.8409 7.16664 13.3334 8.65906 13.3334 10.5C13.3334 12.3409 11.8409 13.8334 10 13.8334ZM16.538 5.16195C16.538 5.82477 16.0008 6.36195 15.338 6.36195C14.6752 6.36195 14.138 5.82477 14.138 5.16195C14.138 4.49922 14.6752 3.96195 15.338 3.96195C16.0008 3.96195 16.538 4.49922 16.538 5.16195Z"
              fill="#99A1AF"
            />
          </g>
          <defs>
            <clipPath id="clip0_6256_36576">
              <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
      );
    case TOPARROW:
      return (
        <svg
          width="30px"
          height="30px"
          viewBox="0 0 1.8 1.8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path width="48" height="48" fill="white" fill-opacity="0.01" d="M0 0H1.8V1.8H0V0z" />
          <path
            d="m0.487 1.125 0.45 -0.45 0.45 0.45"
            stroke="#020618"
            strokeWidth="0.15"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      );
    case BOTTOMARROW:
      return (
        <svg
          fill="#020618"
          width="30px"
          height="30px"
          viewBox="0 -0.225 19.65 19.65"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>down</title>
          <path
            fill="#020618"
            d="m2.4 7.162 1.275 -1.275 6.15 6.112 6.15 -6.112 1.275 1.275 -7.425 7.35z"
          />
        </svg>
      );
    case SEARCH:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g opacity="0.5">
            <path
              fill="none"
              d="M11.2619 11.2802L13.3153 13.3337M12.7227 7.72106C12.7227 10.5123 10.4675 12.7751 7.68566 12.7751C4.90378 12.7751 2.64862 10.5123 2.64862 7.72106C2.64862 4.92978 4.90378 2.66699 7.68566 2.66699C10.4675 2.66699 12.7227 4.92978 12.7227 7.72106Z"
              stroke="#020618"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </svg>
      );
    case ARROWLEFT:
      return (
        <svg width="20px" height="20px" viewBox="0 0 1.2 1.2" fill="none">
          <path width="48" height="48" fill="none" fill-opacity="0.01" d="M0 0H1.2V1.2H0V0z" />
          <path
            d="M0.775 0.9 0.475 0.6l0.3 -0.3"
            stroke="#000000"
            strokeWidth="0.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case ARROWRIGHT:
      return (
        <svg width="20px" height="20px" viewBox="0 0 1.2 1.2" fill="none">
          <path width="48" height="48" fill="none" fill-opacity="0.01" d="M0 0H1.2V1.2H0V0z" />
          <path
            d="m0.475 0.3 0.3 0.3 -0.3 0.3"
            stroke="#000000"
            strokeWidth="0.1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case CALENDAR:
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M2 8.00008C2 5.17165 2 4.42411 2.87868 3.54543C3.75736 2.66675 5.17157 2.66675 8 2.66675C10.8284 2.66675 12.2426 2.66675 13.1213 3.54543C14 4.42411 14 5.17165 14 8.00008C14 10.8285 14 12.2427 13.1213 13.1214C12.2426 14.0001 10.8284 14.0001 8 14.0001C5.17157 14.0001 3.75736 14.0001 2.87868 13.1214C2 12.2427 2 10.8285 2 8.00008Z"
            stroke="#45556C"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.16663 5.33325H13.8333"
            stroke="#45556C"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11 3.33333V2"
            stroke="#45556C"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 3.33333V2"
            stroke="#45556C"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case STAR:
      return (
        <svg
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.38352 0.399313C6.53682 -0.0536249 7.17743 -0.0536256 7.33073 0.399312L8.54628 3.99074C8.61501 4.19379 8.80552 4.33044 9.01989 4.33044H12.9087C13.398 4.33044 13.596 4.96063 13.1947 5.24054L10.0842 7.41006C9.90177 7.5373 9.82532 7.76976 9.89663 7.98045L11.0929 11.515C11.2476 11.9721 10.7291 12.3615 10.3333 12.0854L7.14316 9.86039C6.97131 9.74052 6.74294 9.74052 6.57109 9.86039L3.38095 12.0854C2.98516 12.3615 2.4666 11.9721 2.62131 11.515L3.81762 7.98045C3.88893 7.76977 3.81248 7.5373 3.63005 7.41006L0.519545 5.24054C0.118229 4.96063 0.316294 4.33044 0.805584 4.33044H4.69436C4.90873 4.33044 5.09925 4.19379 5.16797 3.99074L6.38352 0.399313Z"
            fill="#314158"
          />
        </svg>
      );
    case LOCATION:
      return (
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="none"
            d="M10.9666 17.3506C10.6872 17.5498 10.3128 17.5498 10.0334 17.3506C6.00948 14.4811 1.73798 8.58092 6.05558 4.31773C7.23432 3.15386 8.83302 2.5 10.5 2.5C12.167 2.5 13.7657 3.15386 14.9444 4.31773C19.262 8.58092 14.9905 14.4811 10.9666 17.3506Z"
            stroke="#62748E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fill="none"
            d="M10.4999 9.99996C11.4204 9.99996 12.1666 9.25377 12.1666 8.33329C12.1666 7.41282 11.4204 6.66663 10.4999 6.66663C9.57944 6.66663 8.83325 7.41282 8.83325 8.33329C8.83325 9.25377 9.57944 9.99996 10.4999 9.99996Z"
            stroke="#62748E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    default:
      return (
        <svg
          className={classes}
          width="29"
          height="19"
          viewBox="0 0 29 19"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path
              d="M26.58 19H2.42A2.4004 2.4004 0 0 1 0 16.62V2.38A2.4 2.4 0 0 1 2.42 0h24.16A2.4004 2.4004 0 0 1 29 2.38v14.25c-.0165 1.3216-1.0984 2.3811-2.42 2.37zM10 5.83c0-.46-.35-.83-.78-.83H3.78c-.43 0-.78.37-.78.83v3.34c0 .46.35.83.78.83h5.44c.43 0 .78-.37.78-.83V5.83z"
              fill="#DADDE2"
            />
            <path
              d="M25 15h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0h-3c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1zm-6 0H4c-.65 0-1-.3-1-1s.35-1 1-1h3c.65 0 1 .3 1 1s-.35 1-1 1z"
              fill="#B2B6C1"
            />
          </g>
        </svg>
      );
  }
};

export default IconBrandCard;
